import React, { Component } from "react";
import $ from "jquery";
// import "../../public/js/dataTables.uikit.min.js";
import "../../public/css/datatable.css";
require("datatables.net");

class DataTable extends Component {
	constructor(props) {
		super(props);
		this.datatable = null;
		this.$el = null;
	}

	componentDidMount = () => {
		this.$el = $(this.el);
		this.datatable = this.$el.DataTable({
			...this.props.options,
		});
	};

	componentWillUnmount = () => {
		if (this.datatable) this.datatable.destroy();
	};

	// componentDidUpdate = (prevProps) => {
	// 	if (prevProps.queryCounter !== this.props.queryCounter) {
	// 		if (this.props.queryCounter > 1) {
	// 			// this.datatable.destroy();
	// 			// this.$el.empty();
	// 			this.datatable = this.$el.DataTable({
	// 				...this.props.options,
	// 			});
	// 		}
	// 	}
	// };

	refresh = () => {
		// if (destroy) this.datatable.destroy();
		// this.$el.empty();
		this.datatable = this.$el.DataTable({
			...this.props.options,
		});
	};

	reloadAjax = () => {
		this.datatable.ajax.reload();
	};

	render() {
		return (
			<table ref={(el) => (this.el = el)} className={this.props.className}>
				{this.props.children}
			</table>
		);
	}
}

export default DataTable;
